var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`swiper position-relative ${_vm.swiper_params.classes}`},[_c('swiper-container',{ref:_vm.ref_id,attrs:{"init":"false"}},[_vm._t("default")],2),(!_vm.hide_controls)?_c('button',{staticClass:"btn swiper__button swiper__button__prev",style:({
      'margin-left': `-${_vm.swiper_params.button_offset || 0}px`,
    }),attrs:{"type":"button","role":"navigation"},on:{"click":() =>
        _vm.$refs[_vm.ref_id].swiper.slidePrev(
          _vm.swiper_params.slide_speed || _vm.slide_speed
        )}},[_c('vb-icon',{staticClass:"arrow",attrs:{"name":'angle_left',"size":20,"id":"prev-button"}},[_vm._v(" PREV ")])],1):_vm._e(),(!_vm.hide_controls)?_c('button',{staticClass:"btn swiper__button swiper__button__next",style:({
      'margin-right': `-${_vm.swiper_params.button_offset || 0}px`,
    }),attrs:{"type":"button","role":"navigation"},on:{"click":() =>
        _vm.$refs[_vm.ref_id].swiper.slideNext(
          _vm.swiper_params.slide_speed || _vm.slide_speed
        )}},[_c('vb-icon',{staticClass:"arrow",attrs:{"name":'angle_right',"size":20,"id":"next-button"}},[_vm._v(" NEXT ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }